import React from 'react'
import face from './background.jpg'
import facesham from './facesham.png'
import faceshamApp from './faceshamimg.png'
import vrinda from './vrindaimg.png'
import foodeeApp from './foodeeimg.png'
import fin1 from './finimg.png'
import Divider from '@material-ui/core/Divider';
export default function Projects(){
    return(
        <div>
            <div style={{display:"flex"}}> 
                <div style={{padding:"30px 30px 30px 30px",height: "100vh",width:"60vw"}}>
                    <h1 style={{fontFamily:"Monsterrat",fontWeight:"bolder",textAlign:"start"}}>FRIEND IN NEED</h1>
                    <p style={{margin:"50px 30px 0 0",wordWrap:"break-word",textAlign:"justify"}}> An app that helps people who face mental illness from domestic violence.<br/>Main features:  <br/><br/>
A. To educate: <br/>
Forums: Users can share their stories of violence anonymously to motivate the victims  to take action.  
Guidelines page: Page with relevant information about domestic violence. Users can  use this to recognize if they or their acquaintance is facing domestic violence, staying  safe in that situation and steps to seek out help etc.  
<br/><br/>B. To Help:  <br/>
Maps: List of hotlines / emergency numbers / NGOs/ closest Police Station along with  a map for assistance.  
Form: Users can fill a form if they or an acquaintance need assistance/ counselling from  a community or NGO.  <br/><br/>
C. To Alert: <br/> 
SOS: Button in the app which will alert the emergency contacts added by the user.<br/>Recording: Along with contacting the emergency contacts, app will record audio and  video, collecting evidence in case of legal matters. </p>
                </div>
                <div style={{width:"40vw",margin:"50px 0px 50px 0px"}}>
                    <img src={fin1} style={{width:"40vw",marginBottom:"50px"}} />
                </div>
            </div>
            <div style={{display:"flex"}}> 
            <div style={{width:"40vw"}}>
                    <img src={faceshamApp} style={{width:"40vw",marginBottom:"50px"}} />
                </div>
                <div style={{padding:"30px 30px 30px 30px",height: "100vh",width:"60vw"}}>
                    <h1 style={{fontFamily:"Monsterrat",fontWeight:"bolder",textAlign:"start"}}>FACESHAM</h1>
                    <p style={{margin:"50px 30px 0 0",wordWrap:"break-word",textAlign:"justify"}}>FaceSham app provide the interface for the users to filter their media. Initial step will be user uploading the video throught the app. The video is stored in firebase database, also onces the video is uploaded a flask api request is made which then indiates the cloud processing unit/local computer for starting the deeplearning pipeline on the input video. The result of the deep learning model is then sent back to the FaceSham app. The following flowchart diagram explains the same.</p>
                    <br></br>
                    <h1 style={{textAlign:"start"}}>Facesham UI</h1>
                    <img src={facesham} style={{width:"50vw",alignContent:"start"}}/>
                </div>
                
            </div>
            <div style={{display:"flex"}}> 
                <div style={{padding:"30px 30px 30px 30px",height: "100vh",width:"60vw"}}>
                    <h1 style={{fontFamily:"Monsterrat",fontWeight:"bolder",textAlign:"start"}}>STOCKPRED</h1>
                    <p style={{margin:"50px 30px 0 0",wordWrap:"break-word",textAlign:"justify"}}>Stock market prediction is the most 
                        emerging topic in computer engineering and the 
                        financial sector because new methods and 
                        approaches on this matter acquire profit uniformly. 
                        In this project, me along with my friend used sentiment analysis and 
                        machine learning algorithms to establish the 
                        relationship between public opinion and the 
                        changes in the stock markets. We use tweets 
                        tweeted by the various users of a particular 
                        company as data to predict the mood of the people 
                        and combine the same data with previous days
                        stock market values to predict the stock market 
                        movements. Twitter is one of the most popular 
                        social media platforms which provides every user 
                        to express their views about a company or occasion 
                        or anything to the public. Specifically, we fetch all 
                        the live tweets from twitter related to the particular 
                        company using the API. Then we preprocessed the 
                        tweets. All the special characters, emojis,Ascii 
                        characters are removed from the tweets in the data preprocessing. Then, we performed sentimental 
                        analysis on the tweets and segregated them into 
                        neutral, negative and positive tweets. For stock 
                        market prediction we fetched live stock dataset 
                        through yahoo finance API. The stock value dataset 
                        of the company along with the tweets tweeted 
                        about the same company are taken as input to the 
                        machine learning model to predict the stock values 
                        of the same company. We used Apple company 
                        stock data with 3 ML models named 
                        LSTM,ARIMA, Linear Regression. The main aim 
                        of the project is to combine the previous stock data 
                        of the company with the current tweets related to 
                        the company and predict the stock values for the 
                        same company.</p>
                </div>
                <div style={{width:"40vw"}}>
                    <img src={foodeeApp} style={{width:"40vw",marginBottom:"50px"}} />
                </div>
            </div>
            
            <div style={{display:"flex"}}> 
            <div style={{width:"40vw"}}>
                    <img src={vrinda} style={{width:"40vw",marginBottom:"50px"}} />
                </div>
                <div style={{padding:"30px 30px 30px 30px",height: "100vh",width:"60vw"}}>
                    <h1 style={{fontFamily:"Monsterrat",fontWeight:"bolder",textAlign:"start"}}>VRINDA</h1>
                    <p style={{margin:"50px 30px 0 0",wordWrap:"break-word",textAlign:"justify"}}>
                        Vrinda is an event management application which was developed during Covid Time.<br/><br/> Major technologies used during this project was Flutter, Maven, MySQL, springBoot.<br/><br/>
                        Main purpose of the app is to enhance our cultural heritage and give opportunities to artists and performers.
<br/>• Application is mainly focused on three pillars namely Events, User and Teams.
<br/>• This app follows a hierarchy which is based on various roles kept in mind while designing the application which are further categorized as :
<br/>1. User
<br/>2. Team - who will perform kirtans for the users that invite them for the same
<br/>3. Local Admin - who will manage teams (will approve/reject applications of users who want to become teams, and send approvals from their side to
people, so that they become teams)(they have control over a particular area)
4. Super Admin - has control over who will become local admin and of which area</p>
                </div>
                
            </div>
        </div>
        
    )
}